import React from 'react';
import { Link } from 'react-router-dom';

export const FairPolicy = () => {
  const policyData = {
    lastUpdated: "September 6, 2024",
    sections: [
      {
        title: "1. Community Principles & Fair Play Commitment",
        content: `At Namasvi Nexus, we maintain a transparent, fair, and inclusive environment for all creators, participants, organizers, and brand sponsors. This Fair Play Policy outlines mandatory standards to ensure genuine community engagement and truthful contest results.`
      },
      {
        title: "2. Authentic Participation & Verification",
        content: `• Single Account Rule: Participants must register using their authentic social media profile. Creating duplicate dummy accounts to artificially skew votes or claim multiple rewards is strictly prohibited.
• Original Content: Entries must represent the genuine work and talent of the registered participant.`
      },
      {
        title: "3. Strict Anti-Fraud & Voting Integrity Rules",
        content: `• Organic Engagement: Voting is calculated via verified engagement metrics (likes, comments, reposts, shares, saves).
• Prohibited Techniques: Any use of automated bot traffic, click-farms, engagement pods, paid artificial likes, or fake account swarms will trigger automatic detection by our integrity systems.
• Disqualification: Manipulated votes will be purged from the leaderboard, and offending accounts are subject to immediate disqualification without compensation.`
      },
      {
        title: "4. Respectful Content & Zero Harassment",
        content: `• Safe Environment: Discrimination, hate speech, abusive comments, harassment of other creators, or vulgar content will result in immediate removal and permanent banning.
• Intellectual Property Respect: Never submit copyrighted media without authorization.`
      },
      {
        title: "5. Sponsor Collaboration Ethics",
        content: `• Truth in Promotion: Creators collaborating with brand sponsors must adhere to authentic promotion, truthful reviews, and required hashtag / disclaimer disclosures as mandated by advertising standards.`
      },
      {
        title: "6. Violations & Enforcement",
        content: `Violations may result in:
• Official Warning & Score Adjustment
• Immediate Leaderboard Removal & Reward Forfeiture
• Account Suspension or Referral to Law Enforcement for intentional fraud.`
      },
      {
        title: "7. Reporting Violations",
        content: `To report suspected vote manipulation, fake profiles, or community violations, contact our compliance team at integrity@namasvinexus.com or support@namasvinexus.com.`
      }
    ]
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800 flex flex-col font-sans">
      {/* Top Standalone Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-blue-600 to-indigo-600 flex items-center justify-center text-white font-black text-xl shadow-md shadow-blue-500/20">
              N
            </div>
            <div>
              <span className="text-xl font-extrabold tracking-tight text-slate-900">
                NAMASVI<span className="text-blue-600 font-bold">NEXUS</span>
              </span>
              <span className="hidden sm:inline-block ml-3 px-2.5 py-0.5 text-xs font-semibold bg-blue-50 text-blue-700 rounded-full border border-blue-100">
                Official Legal Portal
              </span>
            </div>
          </div>
          <div className="flex items-center space-x-3 text-sm font-medium">
            <Link to="/privacypolicy" className="text-slate-600 hover:text-slate-900 transition-colors pb-1">Privacy</Link>
            <Link to="/termcondition" className="text-slate-600 hover:text-slate-900 transition-colors pb-1">Terms</Link>
            <Link to="/fairpolicy" className="text-blue-600 font-bold border-b-2 border-blue-600 pb-1">Fair Play</Link>
          </div>
        </div>
      </header>

      {/* Main Content Area */}
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 sm:px-6 py-10">
        <div className="bg-white rounded-3xl p-6 sm:p-12 shadow-sm border border-slate-200/80">
          <div className="border-b border-slate-100 pb-6 mb-8 text-center sm:text-left">
            <span className="inline-block px-3 py-1 bg-blue-50 text-blue-700 text-xs font-bold uppercase tracking-wider rounded-lg mb-3">
              Legal Documentation
            </span>
            <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight mb-2">
              Fair Play Policy
            </h1>
            <p className="text-sm font-medium text-slate-500">
              Last Updated: <span className="text-slate-700 font-semibold">{policyData.lastUpdated}</span>
            </p>
          </div>

          <div className="space-y-8">
            {policyData.sections.map((section, index) => (
              <div key={index} className="space-y-2">
                <h2 className="text-xl font-bold text-slate-900">
                  {section.title}
                </h2>
                <p className="text-slate-600 leading-relaxed whitespace-pre-line text-sm sm:text-base">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-slate-200 py-6 text-center text-xs text-slate-500">
        <p>© {new Date().getFullYear()} Namasvi Nexus Private Limited. All rights reserved.</p>
      </footer>
    </div>
  );
};
